import React from 'react'

const OnlineShop = () => {
  return (
    <div>OnlineShop</div>
  )
}

export default OnlineShop